import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  icon: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: pxToRem(16),
  },
  link: {
    selectors: {
      ':active': {
        outline: 0,
        border: 'none',
      },
      ':focus': {
        outline: 0,
        border: 'none',
      },
    },
  },
  downloadButton: {
    textDecoration: 'none',
    fontSize: pxToRem(12),
    'line-height': pxToRem(12),
  },
  viewButton: {
    textDecoration: 'none',
    fontSize: pxToRem(12),
    'line-height': pxToRem(12),
  },
  removeButton: {
    textDecoration: 'none',
    fontSize: pxToRem(12),
    'line-height': pxToRem(12),
  },
});
